module.exports = __webpack_public_path__ + "6742e271fffb00750942a3d6baf4c407.png";